export default class ProductOption {
  /**
   * @param {ShopifyProductOption} option
   */
  constructor(option) {
    this._name = option.name || '';
    this._position = option.position || 0;
    this._values = option.values || [];
  }

  /**
   * @returns {string}
   */
  get name() {
    return this._name;
  }

  /**
   * @returns {number}
   */
  get position() {
    return this._position;
  }

  /**
   * @returns {string[]}
   */
  get values() {
    return this._values;
  }

  /**
   *
   * @return {Object} - Shopify Product Option Object.
   */
  JSON() {
    return {
      name: this.name,
      position: this.position,
      values: this.values,
    };
  }
}
